export const breakpoints = {
  xs: "350px",
  sm: "650px",
  md: "900px",
  lg: "1080px",
  xl: "1400px",
  "2xl": "1800px",
  "3xl": "2200px",
};
